import { getTranslation } from '@travel/translation';

import type { Dictionary } from '@travel/translation';

export function getJoinedTranslation(
  id: string,
  dictionary: Dictionary,
  data?: { [key: string]: any },
): string {
  return getTranslation({ id, data }, dictionary).join('');
}
